import { render, staticRenderFns } from "./Cyz.vue?vue&type=template&id=f7631a36&scoped=true"
import script from "./Cyz.vue?vue&type=script&lang=js"
export * from "./Cyz.vue?vue&type=script&lang=js"
import style0 from "./Cyz.vue?vue&type=style&index=0&id=f7631a36&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7631a36",
  null
  
)

export default component.exports